import React, { useState, useEffect } from "react";
import {
  fetchBotSteps,
  initializeStepStream,
  streamStepChat,
  callFunction,
  createSession,
  saveStepChat,
  executeBot
} from "../../services/api";
import { DataState } from "../../context/DataProvider";
import TextFormat from "../TextFormat";
import Loader from "../custom/Loader";
import { MdKeyboardArrowDown } from "react-icons/md";
import Loader2 from "../custom/Loader2";
import { toast } from "react-hot-toast"

const ExecutionComponent = ({ botId }) => {
  
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
 
  const { userGoogleId, currentTaskId } = DataState();

  const handleAsynchronousBotExecution = async () => {
    try {
      setLoading(true);
      const response = await executeBot(botId, userGoogleId);
      // toast.success("Workflow Execution Started");
    } catch (error) {
      toast.error(error)
    } finally {
      setLoading(false);
    }
  }



  return (
    // <div className="bg-zinc-900 text-white p-2 rounded-lg">
    <div className=" text-white p-2 rounded-lg">
      {loading ? (
        // <div className="flex items-center justify-center text-zinc-400 min-h-4">
        //   {/* <div className="flex items-center justify-center text-zinc-400 min-h-96"> */}
        //   <Loader2 />
        // </div>
        <div className="mt-3 flex justify-end">
          <div  className=" text-zinc-800 px-3 py-1 rounded-lg">
          <Loader2 />
          </div>
       
      </div>
      ) : error ? (
        <p className="text-center text-red-500">Error: {error}</p>
      ) : (
        <div className="mt-3 flex justify-end">
          <button
            onClick={() => {

              // fetchSteps();
              handleAsynchronousBotExecution();
            }}
            disabled={loading}
            className="bg-zinc-200 text-zinc-800 px-3 py-1 rounded-lg"
          >
            {loading ? "Executing" : "Execute"}
          </button>
        </div>
        // <p className="text-center text-zinc-400">No steps available</p>
      )}

    </div>
  );
};

export default ExecutionComponent;
